module.exports = "/static/fonts/fontawesome-webfont.af7ae50.woff2";


//////////////////
// WEBPACK FOOTER
// ./font-awesome/fonts/fontawesome-webfont.woff2
// module id = 1129
// module chunks = 2